import CreditCard from '../../src/legacy/CreditCard.tsx';
export default CreditCard;
